import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getOrganizationChartItemsOfProject } from '../services/getOrganizationChartItemsOfProject.service';

export const loadProjectOrganizationChartItems = createAsyncThunk(
  'organizationCharts/loadProjectOrganizationChartItems',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await getOrganizationChartItemsOfProject(
      selectedProjectId
    );

    return response;
  }
);
